import { useIntl } from "react-intl";
import { useQueryClient } from "react-query";

import AsyncAutocompleteWithQuery, {
  AsyncAutocompleteWithQueryProps,
} from "components/AsyncAutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  InflectionPoint,
  ListResponseOfInflectionPoint,
} from "services/KnowfullyAdminClient";

type SelectInflectionPointTypeProps = {
  onChange: (inflectionPoint: InflectionPoint | null) => void;
} & Omit<
  AsyncAutocompleteWithQueryProps<InflectionPoint>,
  "fetchData" | "failMessage" | "labelField" | "idField" | "onChange"
>;

const SelectInflectionPoint = ({
  onChange,
  ...rest
}: SelectInflectionPointTypeProps) => {
  const { formatMessage: t } = useIntl();
  const queryClient = useQueryClient();
  const { inflectionPointService } = useGlobalContext();

  const fetchInflectionPoints = async (searchTerm: string) => {
    const result = await queryClient.fetchQuery<ListResponseOfInflectionPoint>(
      "inflectionPoints",
      () => inflectionPointService.getInflectionPoints(null)
    );

    return { result, forSearchTerm: searchTerm };
  };

  return (
    <AsyncAutocompleteWithQuery
      {...rest}
      labelField="name"
      idField="id"
      fetchData={fetchInflectionPoints}
      failMessage={t({ id: "selectInflectionPointsFetchFailed" })}
      onChange={onChange}
    />
  );
};

export default SelectInflectionPoint;
